import React, { useState, useEffect } from 'react'
import { NavLink, Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { getSiteData } from '../store/actions'
import logo from '../assets/logo.png'
import { baseURL2 } from '../helper/helper'
import { Menu, X } from 'lucide-react'

export default function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const dispatch = useDispatch();
    const { madarsa } = useSelector((state) => state.reducer || {});

    useEffect(() => {
        if (!madarsa) {
            dispatch(getSiteData());
        }
    }, [dispatch, madarsa]);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    const navLinks = [
        { name: 'Home', path: '/' },
        { name: 'About', path: '/about' },
        { name: 'Institutions', path: '/institution' },
        { name: 'Work', path: '/our-work' },
        { name: 'Online', path: '/online-class' },
        { name: 'Contact', path: '/contact' },
    ];

    return (
        <>
            <header className="sticky top-0 left-0 w-full z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100 transition-all duration-300">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
                    <Link to="/" className="flex items-center gap-3">
                    <img src={baseURL2 + madarsa?.logo || logo} alt={madarsa?.name || "Faiz ul Hasnain"} className="h-10 w-auto" />
                    <div className="flex flex-col">
                        <span className="text-lg font-bold text-primary leading-tight">
                            {madarsa?.name || "Faiz ul Hasnain"}
                        </span>
                        <span className="text-xs text-secondary uppercase tracking-widest font-medium">
                            Foundation
                        </span>
                    </div>
                </Link>

                <nav className="hidden lg:flex items-center gap-8">
                    {navLinks.map((link) => (
                        <NavLink
                            key={link.name}
                            to={link.path}
                            className={({ isActive }) =>
                                `text-sm font-medium transition-colors ${isActive ? 'text-secondary' : 'text-gray-500 hover:text-primary'}`
                            }
                        >
                            {link.name}
                        </NavLink>
                    ))}
                </nav>

                <div className="hidden lg:flex items-center gap-4">
                    <NavLink
                        to="/donation"
                        className="px-6 py-2.5 bg-primary text-white rounded-md text-sm font-medium transition-colors hover:bg-primary-light"
                    >
                        Donate
                    </NavLink>
                </div>

                <button
                    className="lg:hidden p-2 text-primary hover:bg-primary/5 rounded-md transition-colors"
                    onClick={toggleMenu}
                    aria-label="Toggle Menu"
                >
                    {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                </button>
            </div>
        </header>

        {/* Mobile Menu */}
            {isMenuOpen && (
                <div className="lg:hidden fixed left-0 top-20 right-0 bottom-0 bg-white z-40 border-t border-gray-100 flex flex-col shadow-xl overflow-y-auto">
                    <nav className="flex flex-col p-4">
                        {navLinks.map((link) => (
                            <NavLink
                                key={link.name}
                                to={link.path}
                                onClick={toggleMenu}
                                className={({ isActive }) =>
                                    `py-4 px-4 text-lg font-medium border-b border-gray-50 ${isActive ? 'text-secondary bg-secondary/5' : 'text-gray-600'}`
                                }
                            >
                                {link.name}
                            </NavLink>
                        ))}
                        <NavLink
                            to="/donation"
                            onClick={toggleMenu}
                            className="mt-6 px-6 py-3 bg-primary text-white text-center rounded-md font-medium shadow-md"
                        >
                            Donate
                        </NavLink>
                    </nav>
                </div>
            )}
        </>
    )
}
